import {
  Home,
  AgeCalculator,
  AgeDifference,
  DaysLeft,
  PlanetsAge,
  NextBirthday,
  DaysYouLived,
  ZodiacSign,
  DayOfTheWeek,
  DaysDifference,
  ContactUs,
  AboutUs
} from '../pages';
import { paths } from './paths';

export const routes = [
  { path: paths.home, Page: Home },
  { path: paths['age-calculator'], Page: AgeCalculator },
  { path: paths['age-difference'], Page: AgeDifference },
  { path: paths['days-left'], Page: DaysLeft },
  { path: paths['planets-age'], Page: PlanetsAge },
  { path: paths['next-birthday'], Page: NextBirthday },
  { path: paths['days-you-lived'], Page: DaysYouLived },
  { path: paths['zodiac-sign'], Page: ZodiacSign },
  { path: paths['week-day'], Page: DayOfTheWeek },
  { path: paths['days-difference'], Page: DaysDifference },
  { path: paths['contact-us'], Page: ContactUs },
  { path: paths['about-us'], Page: AboutUs }
];
